module.exports = JSON.parse('{"Add Label":"添加标注","Delete measurement":"删除测量"}')